export enum FilterTypes {
    CHECKBOX, DATE, INPUT, TOGGLEMULTIPLE
}
